import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "../apiFetchBaseQuery";
import { DefaultApiSuccessResponse } from "@/types/ApiResponse";

type GetSsoResponse = DefaultApiSuccessResponse & {
	data: {
		url: string;
	};
};

export const creativeBuilderApiSlice = createApi({
	reducerPath: "creativeBuilder",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["ssoLogin"],
	endpoints: builder => ({
		getSsoLoginUrl: builder.query<GetSsoResponse, null>({
			query: () => ({
				url: "creative-builder/sso-login",
			}),
			providesTags: ["ssoLogin"],
		}),
	}),
});

export const { useGetSsoLoginUrlQuery } = creativeBuilderApiSlice;
